/**
 * Encode a value for use in a URL path segment, preserving colons.
 *
 * Colons are legal in path segments (RFC 3986 §3.3) and must not be
 * percent-encoded when used in DID path params (did:method:id). Chi's
 * router extracts URL params from r.URL.RawPath, so %3A would survive
 * to the handler and fail prefix checks like strings.HasPrefix(did, "did:").
 */
export function encodePathSegment(value: string): string {
  return encodeURIComponent(value).replace(/%3A/gi, ':');
}
